import { merge as m } from "./lib/util/merge.js";
import { xlink as o } from "./lib/xlink.js";
import { xml as r } from "./lib/xml.js";
import { xmlns as t } from "./lib/xmlns.js";
import { aria as i } from "./lib/aria.js";
import { html as s } from "./lib/html.js";
import { svg as p } from "./lib/svg.js";
const x = m([r, o, t, i, s], "html"), e = m([r, o, t, i, p], "svg");
export {
  x as html,
  e as svg
};
//# sourceMappingURL=index.js.map
